import { CloseIcon } from '@/components/icons/CloseIcon'
import { cn } from '@/lib/utils'
import { FocusEventHandler, ForwardedRef, MouseEventHandler, forwardRef } from 'react'

export type CloseButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>
  onFocus?: FocusEventHandler<HTMLButtonElement>
  onBlur?: FocusEventHandler<HTMLButtonElement>
  autoFocus?: boolean
  className?: string
}

export const CloseButton = forwardRef(
  (
    { onClick, onFocus, onBlur, autoFocus, className }: CloseButtonProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      autoFocus={autoFocus !== undefined ? autoFocus : true}
      className={cn('rounded-md border-2 border-transparent p-1.5', className)}
    >
      <CloseIcon className="w-4 fill-[#303D4B] dark:fill-[#C4C4C4]" />
    </button>
  )
)
